/**
 * Role: Custom Video script
 */
'use strict';

function customVideoAutoPlay() {
  const containers = document.querySelectorAll('deferred-media.at-deferred');
  containers.forEach(container => {
    const video = container.querySelector('video');
    if (video && container.hasAttribute('autoplay')) video.play();
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, customVideoAutoPlay)
);

function restartVideo() {
  document.querySelectorAll('deferred-media video').forEach(video => {

    video.removeEventListener('mouseenter', video._restartHandler);

    let n = 0;
    video._restartHandler = function () {
      if (!this.paused && this.hasAttribute('autoplay') && n === 0) {
        this.currentTime = 0;
        this.play();
        n++;
      }
    };

    video.addEventListener('mouseenter', video._restartHandler);
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, restartVideo)
);

function videoPlaceholderChange() {
  const posterButtons = document.querySelectorAll('button.has--custom-placeholder:not([data-initialized])');

  posterButtons.forEach(posterButton => {
    posterButton.setAttribute('data-initialized', 'true');
    posterButton.style.position = 'relative';

    const parentContainer = posterButton.closest('deferred-media');
    if (!parentContainer) return;

    const placeholder = posterButton.querySelector('img');
    const customPlaceholder = parentContainer.closest('[data-has-video-placeholder=""]')?.querySelector('[data-custom-placeholder] img');

    if (placeholder && customPlaceholder) {
      if (customPlaceholder.src) placeholder.src = customPlaceholder.src;
      if (customPlaceholder.srcset) placeholder.srcset = customPlaceholder.srcset;
    }

    let isVideoTracked = false;

    posterButton.addEventListener('click', () => {
      const video = parentContainer.querySelector('video');
      if (!video) return;

      if (!isVideoTracked) {
        setupVideoTracking(video, placeholder, posterButton);
        isVideoTracked = true;
      }

      if (customPlaceholder) {
        video.poster = customPlaceholder.src;

        const poster = video.querySelector('img');
        if (poster) poster.src = customPlaceholder.src;
      }

      if (placeholder) placeholder.style.opacity = '';
      Object.assign(posterButton.style, {
        zIndex: '',
        opacity: ''
      });

      video.play();
    });
  });
}

function setupVideoTracking(video, placeholder, posterButton) {
  video.addEventListener('ended', () => {
    console.log('Video ended');
    if (placeholder) placeholder.style.opacity = '1';
    Object.assign(posterButton.style, {
      zIndex: '1',
      opacity: '1'
    });
  });

  video.addEventListener('play', () => {
    if (placeholder) placeholder.style.opacity = '';
    Object.assign(posterButton.style, {
      zIndex: '',
      opacity: ''
    });
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, videoPlaceholderChange)
);

const MOBILE_QUERY = "(max-width: 749px)";
let CUSTOM_VIDEO_SELECTOR = 'deferred-media.at-deferred:not(.insert-deferred)';
function customVideoPlay(selector = CUSTOM_VIDEO_SELECTOR) {
  if (selector instanceof Event) {
    selector = CUSTOM_VIDEO_SELECTOR;
  }

  const containers = document.querySelectorAll(selector);

  containers.forEach(container => {
    if (container.closest('.about-us-front-video')) return;

    const video = container.querySelector('video');
    const btn = container.querySelector('.deferred-media__poster-button');
    if (!video || !btn) return;

    prepareVideo(video);
    attachHoverPlay(video);
    attachClickPlay(video);
    setupOpacityBehavior(video, btn, containers);
  });
}

function prepareVideo(video) {
  video.style.opacity = '';
  video.removeAttribute('controls');
  video.removeAttribute('autoplay');
}

function attachHoverPlay(video) {
  video.addEventListener('mouseover', () => video.play());
}

function attachClickPlay(video) {
  video.addEventListener('click', () => video.play());
}

function setupOpacityBehavior(video, btn, containers) {
  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  video.style.transition = 'opacity .6s';
  btn.style.transition = 'opacity .6s';

  video.addEventListener('play', () => {
    btn.style.opacity = '0';
    video.style.opacity = '1';

    if (isMobile()) {
      containers.forEach(el => el.style.pointerEvents = 'none');
    }
  });

  video.addEventListener('ended', () => {
    video.style.opacity = '';

    if (isMobile()) {
      containers.forEach(el => el.style.pointerEvents = '');
    }

    setTimeout(() => {
      btn.style.opacity = '1';
    }, 300);
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, customVideoPlay)
);

function videoRun() {
  const containers = document.querySelectorAll('.about-us-front-video');
  if (!containers.length) return;
  console.log('videoRun is active');
  
  containers.forEach(container => {

    const HTML = `<div class="border-style custom-section-content">
    <div class="spacing-style layout-panel-flex layout-panel-flex--column section-content-wrapper mobile-column" data-testid="section-content">
      <deferred-media class="at-deferred spacing-style size-style border-style"
        style="--size-style-width: 100%; --size-style-width-mobile: 100%; --size-style-aspect-ratio: 2.083;">
        <video playsinline="playsinline" muted="muted" preload="metadata"
          poster="//m1y0db-vh.myshopify.com/cdn/shop/files/preview_images/a14ab06cbe904e2481827bc723a9a623.thumbnail.0000000000_2500x.jpg?v=1773416410"
          style="transition: opacity 0.6s;">
          <source
            src="//m1y0db-vh.myshopify.com/cdn/shop/videos/c/vp/a14ab06cbe904e2481827bc723a9a623/a14ab06cbe904e2481827bc723a9a623.HD-720p-4.5Mbps-77825705.mp4?v=0"
            type="video/mp4"><img
            src="//m1y0db-vh.myshopify.com/cdn/shop/files/preview_images/a14ab06cbe904e2481827bc723a9a623.thumbnail.0000000000_2500x.jpg?v=1773416410">
        </video>
      </deferred-media>
      <div
        class="image-block image-block--height-fill spacing-style size-style placeholder"
        style="--ratio: 2.0869565217391304; --size-style-width: 100%; --size-style-height: 100%; --size-style-width-mobile: 100%; --size-style-width-mobile-min: 5rem; padding: 0;">
        <img src="//m1y0db-vh.myshopify.com/cdn/shop/files/Main-team-video-placeholder.webp?amp;width=3840" alt=""
        srcset="//m1y0db-vh.myshopify.com/cdn/shop/files/Main-team-video-placeholder.webp?amp;width=240 240w, //m1y0db-vh.myshopify.com/cdn/shop/files/Main-team-video-placeholder.webp?amp;width=352 352w, //m1y0db-vh.myshopify.com/cdn/shop/files/Main-team-video-placeholder.webp?amp;width=832 832w, //m1y0db-vh.myshopify.com/cdn/shop/files/Main-team-video-placeholder.webp?amp;width=1200 1200w, //m1y0db-vh.myshopify.com/cdn/shop/files/Main-team-video-placeholder.webp?amp;width=1600 1600w, //m1y0db-vh.myshopify.com/cdn/shop/files/Main-team-video-placeholder.webp?amp;width=1920 1920w, //m1y0db-vh.myshopify.com/cdn/shop/files/Main-team-video-placeholder.webp?amp;width=2560 2560w, //m1y0db-vh.myshopify.com/cdn/shop/files/Main-team-video-placeholder.webp?amp;width=3840 3840w"
        width="1920" height="920" loading="lazy" class="image-block__image border-style" style="--ratio: 2.0869565217391304; object-fit: contain;" sizes="auto, (min-width: 750px) 100vw, 100vw">
      </div>
    </div>`;

    container.innerHTML = HTML;

    const video = container.querySelector('video');
    if (!video) return;

    const siteHeader = document.querySelector('#header-group header');
    const placeholder = container.querySelector('.placeholder');

    const match = HTML.match(/width="(\d+)"\s+height="(\d+)"/);

    let def = true;
    function getRatio() {
      if (match) {
          const width = parseInt(match[1], 10);
          const height = parseInt(match[2], 10);
          const bodyWidth = document.body.getBoundingClientRect().width;
          const headerHight = siteHeader?.getBoundingClientRect().height ?? 0;
          def = window.innerHeight - headerHight < bodyWidth * (height / width);
          return def;
      } else {
          console.warn('Width and height were not found in the string.');
      }
    }
    getRatio();

    placeholder.style.display = 'none';
    video.style.opacity = '1';

    function scrollToTop() {
      container.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      });
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (video.ended) return;

      if (entry.isIntersecting) {
        scrollToTop();
        Object.assign(video.style, {
          zIndex: '1'
        });
        placeholder.style.display = 'none';
        if (def === true) siteHeader.style.transform = 'translateY(-110%)';
        video.play();
      }

    }, { threshold: 0.1 });

    observer.observe(container);

    if (placeholder) {
      video.addEventListener('ended', () => {
        placeholder.style.display = 'block';
        setTimeout(() => {
          placeholder.style.filter = 'blur(0)';
        }, 0);
        setTimeout(() => {
          siteHeader.style.transform = 'translateY(0)';
        }, 1000);
      });
    }

  });
}
if (window.matchMedia("(min-width: 750px)").matches) {
  ['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
    document.addEventListener(event, videoRun)
  );
}

function memberDataInsert() {
  const container = document.querySelector('.members-insert-container');
  if (!container) return;

  const CONFIGS = [
    {
      name: 'Ika Shalev',
      role: 'CEO and Founder',
      dataMediaSource: 'bb69e78fb7e144ed93c6359274e3e4b3',
      mbps: '77060803'
    },
    {
      name: 'Dave Ben David',
      role: 'CEO and Founder',
      dataMediaSource: '212cb7c8e05f47fea65a43eb00bd9d93',
      mbps: '77060873'
    },
    {
      name: 'Lorin Shalev',
      role: 'Head of Jewelry Apartment',
      dataMediaSource: 'f13082c394274d92bc6fd6ad7cf0acd3',
      mbps: '77060954'
    },
    {
      name: 'Nicole Ben David',
      role: 'Head of Adminstration',
      dataMediaSource: '1cf876023284418db311619963b552ba',
      mbps: '77061008'
    },
    {
      name: 'Vlad Telpis',
      role: 'Chief of Marketing',
      dataMediaSource: '4116948151e44b4aa1958ed23728a20f',
      mbps: '76958915'
    },
    {
      name: 'Maximilan Reif-Breitwieser',
      role: 'Watchmaker',
      dataMediaSource: '55d142fab9224d5e8966e61675faffeb',
      mbps: '77060677'
    },
    {
      name: 'Michael Chumak',
      role: 'Sales manager',
      dataMediaSource: '27c4f1b26f1642f2ab359fe8614045ac',
      mbps: '77060747'
    }
  ];

  const img = (id, w) =>
    `//m1y0db-vh.myshopify.com/cdn/shop/files/preview_images/${id}.thumbnail.0000000000.jpg?amp;width=${w}`;

  function insert(id, mbps, name, role) {
    const HTML = `
      <div class="our-team js-insert group-block-content layout-panel-flex layout-panel-flex--column mobile-column">
        <deferred-media class="at-deferred insert-deferred spacing-style size-style border-style" style="--size-style-aspect-ratio: 0.713;">
          <button class="button deferred-media__poster-button at-play button-unstyled" data-role="video-play" aria-label="Video laden:" type="button" style="--video-aspect-ratio: 0.713;">
            <img
              src="${img(id, 3840)}"
              alt=""
              srcset="
                ${img(id, 240)} 240w,
                ${img(id, 352)} 352w,
                ${img(id, 832)} 832w,
                ${img(id, 1200)} 1200w,
                ${img(id, 1600)} 1600w,
                ${img(id, 1920)} 1920w,
                ${img(id, 2560)} 2560w,
                ${img(id, 3840)} 3840w
              "
              width="3840" height="5376" sizes="(min-width: 750px) 50vw, 100vw" class="deferred-media__poster-image">
          </button>
          <video playsinline muted preload="metadata"
            poster="//m1y0db-vh.myshopify.com/cdn/shop/files/preview_images/${id}.thumbnail.0000000000_2500x.jpg">
            <source src="//m1y0db-vh.myshopify.com/cdn/shop/videos/c/vp/${id}/${id}.HD-1080p-7.2Mbps-${mbps}.mp4?v=0" type="video/mp4">
          </video>
        </deferred-media>
        <div class="group-block group-block--height-fit group-block--width-fill border-style spacing-style size-style">
          <div class="text-content group-block-content layout-panel-flex layout-panel-flex--column mobile-column">
            <rte-formatter class="name spacing-style text-block rte rte">
              <h4>${name}</h4>
            </rte-formatter>
            <rte-formatter class="role spacing-style text-block rte rte">
              <p>${role}</p>
            </rte-formatter>
          </div>
        </div>
      </div>
    `;

    container.insertAdjacentHTML('beforeend', HTML);
  }

  const SLIDESHOW_ARROWS = `<slideshow-arrows class="for-members-slider" style="position: static; pointer-events: all">
    <button class="slideshow-control--previous slideshow-control--style-arrow
        button button-unstyled button-unstyled--transparent flip-x
      " aria-label="Vorherige Folie" ref="prev">
      <span class="svg-wrapper icon-arrow"><svg class="icon arrow-long" width="100" height="17" viewBox="0 0 100 17"
          fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 9.00008C0.447716 9.00008 0 8.55237 0 8.00008C0 7.4478 0.447716 7.00008 1 7.00008V8.00008V9.00008ZM92.5071 16.1071C92.1166 16.4976 91.4834 16.4976 91.0929 16.1071C90.7024 15.7166 90.7024 15.0834 91.0929 14.6929L91.8 15.4L92.5071 16.1071ZM99 8.2L99.7071 7.49289C99.8946 7.68043 100 7.93478 100 8.2C100 8.46522 99.8946 8.71957 99.7071 8.90711L99 8.2ZM91.0929 1.70711C90.7024 1.31658 90.7024 0.683418 91.0929 0.292893C91.4834 -0.097631 92.1166 -0.0976311 92.5071 0.292893L91.8 1L91.0929 1.70711ZM99 8.00008V9.00008H1V8.00008V7.00008H99V8.00008ZM91.8 15.4L91.0929 14.6929L98.2929 7.49289L99 8.2L99.7071 8.90711L92.5071 16.1071L91.8 15.4ZM99 8.2L98.2929 8.90711L91.0929 1.70711L91.8 1L92.5071 0.292893L99.7071 7.49289L99 8.2Z"
            fill="#44545B"></path>
        </svg></span>
    </button>
    <button
      class="slideshow-control--next slideshow-control--style-arrow button button-unstyled button-unstyled--transparent"
      aria-label="Nächste Folie" ref="next">
      <span class="svg-wrapper icon-arrow"><svg class="icon arrow-long" width="100" height="17" viewBox="0 0 100 17"
          fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 9.00008C0.447716 9.00008 0 8.55237 0 8.00008C0 7.4478 0.447716 7.00008 1 7.00008V8.00008V9.00008ZM92.5071 16.1071C92.1166 16.4976 91.4834 16.4976 91.0929 16.1071C90.7024 15.7166 90.7024 15.0834 91.0929 14.6929L91.8 15.4L92.5071 16.1071ZM99 8.2L99.7071 7.49289C99.8946 7.68043 100 7.93478 100 8.2C100 8.46522 99.8946 8.71957 99.7071 8.90711L99 8.2ZM91.0929 1.70711C90.7024 1.31658 90.7024 0.683418 91.0929 0.292893C91.4834 -0.097631 92.1166 -0.0976311 92.5071 0.292893L91.8 1L91.0929 1.70711ZM99 8.00008V9.00008H1V8.00008V7.00008H99V8.00008ZM91.8 15.4L91.0929 14.6929L98.2929 7.49289L99 8.2L99.7071 8.90711L92.5071 16.1071L91.8 15.4ZM99 8.2L98.2929 8.90711L91.0929 1.70711L91.8 1L92.5071 0.292893L99.7071 7.49289L99 8.2Z"
            fill="#44545B"></path>
        </svg></span>
    </button>
  </slideshow-arrows>`;

  container.insertAdjacentHTML('afterend', SLIDESHOW_ARROWS);

  CONFIGS.forEach(({ dataMediaSource, mbps, name, role }) =>
    insert(dataMediaSource, mbps, name, role)
  );

  function slider() {
    const slides = container.querySelectorAll('.our-team.js-insert');
    const parent = container.closest('.mobile-members-insert');
    const arrowsContainer = parent.querySelector('.slideshow-arrows');
    if (arrowsContainer && slides.length <= 1) arrowsContainer.style.display = 'none';
    if (slides.length <= 1) return;
    const prevBtn = parent.querySelector('.slideshow-control--previous');
    const nextBtn = parent.querySelector('.slideshow-control--next');

    const step = container.closest('.mobile-members-insert').getBoundingClientRect().width;

    let n = 0;
    function btnSlide() {
      if (!prevBtn || !nextBtn) return;

      function updateSlider(direction) {
        if (direction === 'next') {
          prevBtn.style.opacity = '';
          if (n < slides.length - 1) n++;
          n >= slides.length - 1 ? nextBtn.style.opacity = '.5' : nextBtn.style.opacity = '';
        } else if (direction === 'prev') {
          nextBtn.style.opacity = '';
          if (n > 0) n--;
          n === 0 ? prevBtn.style.opacity = '.5' : prevBtn.style.opacity = '';
        }
        container.style.transform = `translateX(${-step * n}px)`;
      }

      nextBtn.addEventListener('click', () => updateSlider('next'));
      prevBtn.addEventListener('click', () => updateSlider('prev'));

      return n;
    }
    btnSlide();

    function touchSlide() {
      container.addEventListener('touchstart', handleTouchStart, false);
      container.addEventListener('touchend', handleTouchEnd, false);

      let xDown = null;
      let yDown = null;

      function handleTouchStart(e) {
        xDown = e.touches[0].clientX;
        yDown = e.touches[0].clientY;
      };

      function handleTouchEnd(e) {
        if (!xDown || !yDown) return;

        let xUp = e.changedTouches[0].clientX;
        let yUp = e.changedTouches[0].clientY;
        let xDiff = xDown - xUp;
        let yDiff = yDown - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
          if (xDiff > 0) {
            prevBtn.style.opacity = '';
            if (n < slides.length - 1) n++;
            n >= slides.length - 1 ? nextBtn.style.opacity = '.5' : nextBtn.style.opacity = '';
          } else {
            nextBtn.style.opacity = '';
            if (n > 0) n--;
            n === 0 ? prevBtn.style.opacity = '.5' : prevBtn.style.opacity = '';
          }
        } else {
          return;
        }
        xDown = null;
        yDown = null;

        container.style.transform = `translateX(${-step * n}px)`;
      };
      return n;
    }
    touchSlide();

  }
  slider();

  customVideoPlay('.our-team.js-insert deferred-media');

}
if (window.matchMedia("(max-width: 749px)").matches) {
  ['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
    document.addEventListener(event, memberDataInsert)
  );
}

// *** video Safe Mode
function videoSafeMode() {
  const videos = document.querySelectorAll('.at-deferred video');
  videos.forEach(video => {
    if (video.closest('.owners, .persons') && (window.matchMedia("(min-width: 750px)").matches)) return;

    let th = .1;
    if (video.closest('.our-team, .owners, .persons')) th = .8;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            console.log('Autoplay could be blocked by the browser')
          });
        }
      } else {
        video.pause();
      }
    }, {
      threshold: th
    });

    observer.observe(video);
  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, videoSafeMode)
);
